import { render, staticRenderFns } from "./clip-img-new.vue?vue&type=template&id=ae4c459c&scoped=true"
import script from "./clip-img-new.vue?vue&type=script&lang=js"
export * from "./clip-img-new.vue?vue&type=script&lang=js"
import style0 from "./clip-img-new.vue?vue&type=style&index=0&id=ae4c459c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae4c459c",
  null
  
)

export default component.exports